import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
// Servicio
import { PrestamosService } from '../../../services/prestamos.service';
import { Helper } from '../../../helpers/helper';
import { Factura } from '../../../interfaces/prestamos.interface';
@Component({
  selector: 'app-recibo-ingreso',
  templateUrl: './recibo-ingreso.component.html',
  styleUrls: ['./recibo-ingreso.component.css']
})
export class ReciboIngresoComponent implements OnInit, AfterViewInit {
  @ViewChild('capitalInput') private elementRef: ElementRef;
  @Input() prestamo: any;
  @Input() modals: any;
  Math: Math;
  capital;
  cuotas: Array<any> = [];
  loading = false;
  datosFactura: Factura;
  constructor(public activeModal: NgbActiveModal, private prestamoService: PrestamosService, private helper: Helper) {
    this.Math = Math;
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.elementRef.nativeElement.focus();
  }

  detallarPrestamo() {
    this.cuotas = [];
    const cargoMora = this.prestamo.cuotas.reduce( (a, b) => a + b.mora, 0);
    this.capital = (parseFloat(this.capital) >
                    (this.prestamo.capital + this.prestamo.totalInteres - this.prestamo.total_pagado + cargoMora) ?
                     this.prestamo.capital + this.prestamo.totalInteres - this.prestamo.total_pagado + cargoMora :
                     this.capital);

    let montoPagado  = parseFloat(this.capital);
    let index = 0;
    while (montoPagado > 0) {
      if (montoPagado >= (
        this.prestamo.cuotas[index].monto_cuota -
        this.prestamo.cuotas[index].total_pagado +
        this.prestamo.cuotas[index].mora
      )) {
        this.prestamo.cuotas[index].detalle = (
          this.prestamo.cuotas[index].monto_cuota -
          this.prestamo.cuotas[index].total_pagado +
          // tslint:disable-next-line:max-line-length
          this.prestamo.cuotas[index].mora !== this.prestamo.cuotas[index].monto_cuota + this.prestamo.cuotas[index].mora ? 'Completivo' : 'Pagado');

        this.prestamo.cuotas[index].monto_pagado =
        this.prestamo.cuotas[index].monto_cuota - this.prestamo.cuotas[index].total_pagado;
        this.prestamo.cuotas[index].mora_pagada = this.prestamo.cuotas[index].mora;
        montoPagado -= Math.ceil(this.prestamo.cuotas[index].monto_pagado);
        montoPagado -= this.prestamo.cuotas[index].mora;
      } else {

        if (montoPagado >= this.prestamo.cuotas[index].mora) {

          this.prestamo.cuotas[index].detalle = 'Abonado';
          this.prestamo.cuotas[index].mora_pagada = this.prestamo.cuotas[index].mora;
          montoPagado -= this.prestamo.cuotas[index].mora;
          this.prestamo.cuotas[index].monto_pagado = montoPagado;
          montoPagado -= Math.ceil(this.prestamo.cuotas[index].monto_pagado);
        } else {
          this.prestamo.cuotas[index].detalle = 'Pendiente';
          this.prestamo.cuotas[index].mora_pagada = montoPagado;
          montoPagado = 0;
          this.prestamo.cuotas[index].monto_pagado = 0;
        }
      }

      this.cuotas.push(this.prestamo.cuotas[index]);
      index++;
    }

  }

  realizarPago() {
    if (this.cuotas.length > 0) {
        const d = new Date();

        const prestamo = {
          ID_EMPLEADO: this.prestamo.ID_EMPLEADO,
          ID_CLIENTE: this.prestamo.cliente.ID_CLIENTE,
          total_cuotas: this.prestamo.total_cuotas,
          cuotas: this.cuotas,
          ID_PRESTAMO: this.prestamo.ID_PRESTAMO,
          // tslint:disable-next-line:max-line-length
          fecha_pago: this.prestamo.fecha_pago.year + '-' + this.prestamo.fecha_pago.month + '-' + this.prestamo.fecha_pago.day + ` ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`
        };
        this.loading = true;
        this.prestamoService.realizarPago(prestamo).subscribe(res => {
          setTimeout(() => this.loading = false, 1);
          if (res) {
          this.registrarRecibo(prestamo.fecha_pago)
          .then(() => this.activeModal.close(res));
        }
      }, err => {
        setTimeout(() => this.loading = false, 1);
        if (err) {
          this.activeModal.close({ err });
        }
      });
    }
  }

  private registrarRecibo(fecha_pago): Promise<any> {
    /* ============================================================================
      Inicializar la variable datosFactura para registrar el recibo en la DB-LOCAL
      ============================================================================
    */

    return new Promise((resolve, rejects ) => {
      const d = new Date(this.prestamo.fecha_pago.year + '-' + this.prestamo.fecha_pago.month + '-' + this.prestamo.fecha_pago.day);
      const t = new Date(this.helper.getDate());
      const date = (d.getMonth() + 1) + '' +
                    d.getDate() + '' +
                    t.getHours() + '' +
                    t.getMinutes() + '' +
                    t.getSeconds();

      const reciboDetalle = [];
      let suma = 0;
      for (const cuota of this.cuotas) {
        reciboDetalle.push({
          ID_CUOTA: cuota.ID_CUOTA,
          monto_pagado: cuota.monto_pagado,
          numero_cuota: cuota.numero_cuota,
          mora: cuota.mora_pagada,
          tipo: (cuota.monto_pagado >= cuota.monto_cuota - cuota.total_pagado ?
                (cuota.monto_pagado !== cuota.monto_cuota ? 'Completivo' : 'Pago') : 'Abono'),
        });

        suma += cuota.monto_pagado;
      }

      this.datosFactura = {
        ID_RECIBO: date + '-' + this.prestamo.ID_PRESTAMO +  '-' +  this.cuotas[0].numero_cuota,
        negocio: '',
        ID_CLIENTE: this.prestamo.cliente.ID_CLIENTE,
        ID_PRESTAMO: this.prestamo.ID_PRESTAMO,
        fecha_inicia: this.prestamo.fecha_inicia.split('T')[0],
        fecha_termina: this.prestamo.fecha_vence.split('T')[0],
        ID_EMPLEADO: this.prestamo.ID_EMPLEADO,
        monto_pagado: suma,
        fecha_registro: fecha_pago,
        cuotas: reciboDetalle
      };

      this.prestamoService.registrarRecibo(this.datosFactura)
      .subscribe(
        () => resolve('OK'),
        err => {
          localStorage.setItem(`_error_registro_recibo_${this.datosFactura.ID_RECIBO}`, JSON.stringify(this.datosFactura));
          resolve(err);
        });
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/recibo-ingreso/recibo-ingreso.component.ts